module.exports = require('./dist/vue-lightbox.js')



//////////////////
// WEBPACK FOOTER
// ./~/vue-lightbox/index.js
// module id = 411
// module chunks = 0